module.exports = __webpack_public_path__ + "media/RSVP_Session.3dc1eced.mp4";